<template>
  <br><br>
  <div class="div_box">
    <p>
      You must be logged in with the google account entered in the game to view your coins and claim them
    </p>
    <br>
    <button class="button-36" @click="googleSignIn">
      Sign In with Google...
    </button>

    
    
      <br>
    <p>
    <label class="form__label"> {{  wellcomeNickname }}
      <br>
      <br>
    </label> 
    </p>

    
    <p>
      <label for="name" class="form__label">Total Clained</label>
    </p>
    <p>
    <input size="10"  placeholder="$ERFC Clained" type="text" name="erfcClained" class="form__input_text_big" v-model="erfcClained" readonly/>
    </p>

    <p>
      <label for="name" class="form__label">Total for Clain</label>
    </p>
    <p>
    <input size="10"  placeholder="$ERFC Unclained" type="text" name="erfcUnclained" class="form__input_text_big" v-model="erfcunclained" readonly/>
    </p>

    <br>
    <button class="button-36" @click="clainRewards" v-bind:disabled="btnEnabled">
      Claim now
    </button>


  </div>
  <br><br><br><br><br><br><br><br><br><br><br><br>
</template>

<script>

import firebase from "firebase/compat/app"
import "firebase/compat/auth"

//import { getDatabase, ref, child, get } from "firebase/database";
//import { getDatabase, ref, onValue} from "firebase/database";

//import { getDatabase } from "firebase/database";
import { getDatabase, ref, onValue, update} from "firebase/database";
//import { getSystemErrorMap } from "util";
//const { ethereum } = window
import { ethers } from "ethers";

require("firebase/database");
export default {
  name: "SignUp"
  , data() {
      return {
        wellcomeNickname: '',
        erfcunclained: '',
        erfcClained: '',
        userAuth: null,
        btnEnabled: false
      }}
    ,methods: {
    googleSignIn: function() {
      
    

      let provider = new firebase.auth.GoogleAuthProvider();
      

      const database = getDatabase();


      
      let user;
      this.$parent.userAuth = firebase.auth()
        .signInWithPopup(provider)
        .then((result) => {
          let token = result.credential.accessToken;
          user = result.user;
            console.log("Id:"+user.uid);
            console.log(token) // Token
            console.log(user) // User that was authenticated


            
              const starCountRef = ref(database, 'user/' + user.uid );
              onValue(starCountRef, (snapshot) => {
                try{
                const data = snapshot.val();
                console.log("Data: "+data.amountERFC);
                this.$parent.erfcunclained = data.amountERFC;
                this.$parent.erfcClained = data.clainedERFC;
                this.$parent.nickname = data.nickName
                this.$parent.userWallet = data.wallet;
                this.$parent.uid = user.uid;
                
                this.erfcunclained = data.amountERFC;
                this.erfcClained = data.clainedERFC;
                this.nickname = data.nickName
                this.userWallet = data.userWallet;                
                this.wellcomeNickname = 'Hello ' + data.nickName
                



                } catch (error){ 
                  console.log('Error: ' + error)
                  this.$parent.erfcunclained = 0;
                  this.$parent.erfcClained = 0;
                  this.$parent.nickname = '';
                  this.$parent.userWallet = '';
                  this.wellcomeNickname = '';
                  

                  alert("Game profile not found for this account.");
                  
                }
              });


        })
        .catch((err) => {
          console.log(err); // This will give you all the information needed to further debug any errors
        });
      
        },clainRewards: function(){

                    this.btnEnabled = true;

                    if (this.$parent.erfcunclained === '' || this.$parent.erfcunclained === 0){
                      alert("You have no coins to claim");
                      return;
                    }

                 

                      /*
                      let provider = new firebase.auth.GoogleAuthProvider();
                      
                      firebase.initializeApp(firebaseConfig);
                      const database = getDatabase();
                      
                      let userWallet;
                      let user;
                      this.userAuth = firebase.auth()
                        .signInWithPopup(provider)
                        .then((result) => {
                          let token = result.credential.accessToken;
                          user = result.user;
                            console.log("Id:"+user.uid);
                            console.log(token) // Token
                            console.log(user) // User that was authenticated
                            
                              const starCountRef = ref(database, 'user/' + user.uid );
                              onValue(starCountRef, (snapshot) => {
                                try{
                                const data = snapshot.val();
                                console.log("Data: "+data.amountERFC);
                                this.erfcunclained = data.amountERFC;
                                this.erfcClained = data.clainedERFC;
                                userWallet = data.wallet;

                                this.nickname = 'Hello ' + data.nickName
                                */
                                console.log("Running claim...");
                                let userWallet = this.$parent.userWallet;
                                var connectedWallet;
                                window.ethereum.request({method:'eth_requestAccounts'})
                                .then(res=>{
                                        // Return the address of the wallet
                                        
                                        
                                        connectedWallet = ""+ res;

                                        console.log("Address 2:" + connectedWallet) ;
                                      // this.getBalance(res);
                                  
                                      

                                      
                                        
                                        if (userWallet.toLocaleLowerCase().trim() ==  connectedWallet.toLocaleLowerCase().trim() ){
                                          // -> call bc method
                          //                const ethers = require('ethers');
                        
                                            // The Contract interface
                                            let abi = [
                                            {
                                                "anonymous": false,
                                                "inputs": [
                                                  {
                                                    "indexed": false,
                                                    "internalType": "uint256",
                                                    "name": "amount",
                                                    "type": "uint256"
                                                  }
                                                ],
                                                "name": "Bought",
                                                "type": "event"
                                              },
                                              {
                                                "inputs": [
                                                  {
                                                    "internalType": "uint256",
                                                    "name": "_amount",
                                                    "type": "uint256"
                                                  }
                                                ],
                                                "name": "ERFCClaim",
                                                "outputs": [],
                                                "stateMutability": "nonpayable",
                                                "type": "function"
                                              }
                                        ]

                                        const contractAddress = "0x7D81e7128c51F815f4d7b4C7C17025304C864166"; // production
                                        //const contractAddress = "0xBEee8Ec57c07BBbF2A002644D73fCEAf0E20b776"; // testnet
                                            
                                        
                                          const provider = new ethers.providers.Web3Provider(window.ethereum)
                                          const signer = provider.getSigner(userWallet);
                                           const contract = new ethers.Contract(contractAddress, abi, provider);

                                           const daiWithSigner = contract.connect(signer);
                                          
                                            var erfcSend = ethers.utils.parseEther(""+this.erfcunclained )   

                                            daiWithSigner.ERFCClaim(erfcSend ).then( ret => {
                                                if(ret.hash === ''){
                                                  console.log("$ERFC Claim ret hash: " + ret.hash ) ;
                                                }else{
                                                  
                 
                                                 const database = getDatabase();

                                                 var valc = 0;
                                                 if (this.$parent.erfcunclained < 200000){
                                                  valc = this.$parent.erfcunclained;
                                                 }else{
                                                  valc = 199999;
                                                 }

                                                 const updates = {};
                                                  updates['user/' +this.$parent.uid + "/amountERFC"] = ( this.$parent.erfcunclained - valc);
                                                  updates['user/' +this.$parent.uid + "/clainedERFC"] = this.$parent.erfcClained + valc;

                                                  update(ref(database), updates);

                                                  alert('You can see this transaction in BSC Scan by the link below, https://bscscan.com/tx/'+ret.hash+'  ');


                                                }

                                              try{
                                                console.log(ret.transactionHash);
                                              }catch (error){
                                                console.log(error);
                                              }

                                              this.btnEnabled = false;
                                              
                                            }).catch((err) => {
                                              console.log(err); // This will give you all the information needed to further debug any errors
                                              this.btnEnabled = false;
                                            });

                     
                                      }else{
                                        alert("Connected wallet ("+connectedWallet.toUpperCase()+") is not equal Game configured wallet ("+userWallet.toUpperCase()+")");
                                          this.btnEnabled = false;
                                          return;
                                      }

                                      // <-
                                
                                })

/*                          
                              
                              } catch (error){ 
                                  console.log('Error: ' + error)
                                  this.erfcunclained = '';
                                this.erfcClained = '';
                                this.nickname = '';
                                  alert("Game profile not found for this account.");
                                  
                                }
                              });


                        })
                        .catch((err) => {
                          console.log(err); // This will give you all the information needed to further debug any errors
                        });

                        */

    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 20%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}


.form__input_label {
  font-family: 'Roboto', sans-serif;
  color: rgba(85, 85, 204, 0);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 20%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}


.form__input_text_big {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 40%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}

.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}

.div_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 40%;
  display: block;
  
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}

.button-36 {
  background-image: linear-gradient(92.88deg, #455EB5 9.16%, #5643CC 43.89%, #673FD7 64.72%);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
  font-family: "Inter UI","SF Pro Display",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 4rem;
  padding: 0 1.6rem;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  transition: all .5s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-36:hover {
  box-shadow: rgba(80, 63, 205, 0.5) 0 1px 30px;
  transition-duration: .1s;
}

@media (min-width: 768px) {
  .button-36 {
    padding: 0 2.6rem;
  }
}
</style>
